import styled from 'styled-components';

export const RequestDetailsStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  gap: 0.4rem;
`;

export const RequestDetailsStatusTitle = styled.p`
  font-weight: 600;
  font-size: 0.75rem;
  color: ${(props) => props.theme.textMainColor};

  @media (max-width: 710px) {
    font-size: 14px;
    font-weight: 600;
  }
`;

export const RequestDetailsParagraph = styled.p`
  color: ${(props) => props.theme.popupParagraphColor};
  font-size: 14px;
  font-weight: 400;

  @media (max-width: 710px) {
    font-size: 16px;
    font-weight: 400;
  }
`;
